import React, { useEffect, useState } from 'react';
import { listFilesUploaded, downloadFileTenants, deleteFileTenant } from '../../../services';
import '../../../libs/bulma.min.css';
import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPlay, faStop, faTrash } from '@fortawesome/free-solid-svg-icons';

const API_URL = "http://200.174.142.40";

export default function AudioManagerInline() {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [playingItem, setPlayingItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setMessage("");
    try {
      const result = await listFilesUploaded();
      setLoading(false);

      if (!result || result.error) {
        setMessage(result?.message || "Erro ao buscar lista de arquivos.");
        return;
      }

      const tempData = [];
      for (const [tenantKey, foldersObj] of Object.entries(result)) {
        for (const [folderName, filesArr] of Object.entries(foldersObj)) {
          filesArr.forEach((fileName) => {
            tempData.push({ tenant: tenantKey, folder: folderName, fileName });
          });
        }
      }

      // Ordenar por nome de arquivo
      tempData.sort((a, b) => a.fileName.localeCompare(b.fileName));
      setData(tempData);
    } catch (err) {
      console.error(err);
      setMessage("Erro ao buscar lista de arquivos.");
    }
  };

  const handleDelete = async (item) => {
    const { tenant, folder, fileName } = item;
    setMessage("");
    try {
      const response = await deleteFileTenant({ tenant, type: folder, fileName });
      if (response.status === 200) {
        setMessage("Arquivo deletado com sucesso.");
        fetchAll();
      } else {
        setMessage(response.data?.message || "Erro ao deletar arquivo.");
      }
    } catch (err) {
      console.error(err);
      setMessage("Erro ao deletar arquivo.");
    }
  };

  const handleDownload = async (item) => {
    const { tenant, folder, fileName } = item;
    setMessage("");
    try {
      const response = await downloadFileTenants({ tenant, type: folder, fileName });
      if (response.status !== 200) {
        setMessage(response.data?.message || "Erro ao fazer download.");
        return;
      }
      const blob = new Blob([response.data]);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link);
    } catch (err) {
      console.error(err);
      setMessage("Erro ao fazer download.");
    }
  };

  const handlePlay = (item) => {
    if (playingItem && playingItem.fileName === item.fileName) {
      setPlayingItem(null);
    } else {
      setPlayingItem(item);
    }
  };

  const getPlayUrl = (item) => {
    const { tenant, folder, fileName } = item;
    return `${API_URL}/api/uploads/play?tenant=${tenant}&type=${folder}&fileName=${fileName}`;
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="columns">
            <div className="column is-half has-text-centered is-offset-one-quarter">
              <strong className="is-size-3">LISTA DE ÁUDIOS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <div className="table-container column is-flex-wrap-wrap is-offset-4 is-half">
            {message && <div className="text-red-500">{message}</div>}
            <table className="table is-bordered is-striped is-narrow is-hoverable is-half">
              <thead>
                <tr className='is-size-7 has-text-centered has-background-grey-lighter'>
                  <th className="border p-2 is-size-6">Cliente</th>
                  <th className="border p-2 is-size-6">Tipo</th>
                  <th className="border p-2 is-size-6">Arquivo</th>
                  <th className="border p-2 is-size-6">Ações</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  const isPlaying = playingItem && playingItem.fileName === item.fileName;
                  return (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className="border p-2 is-family-monospace">{item.tenant}</td>
                      <td className="border p-2 is-family-monospace">{item.folder}</td>
                      <td className="border p-2 is-family-monospace">{item.fileName}</td>
                      <td className="border p-2 space-x-2 is-family-monospace">
                        <button
                          className="button is-danger is-small mx-1 px-3"
                          onClick={() => handleDelete(item)}
                        >
                          <span className="icon">
                            <FontAwesomeIcon icon={faTrash} fixedWidth />
                          </span>
                        </button>
                        <button
                          className="button is-success is-small mx-1 px-3"
                          onClick={() => handlePlay(item)}
                        >
                          {isPlaying ? (
                            <span className="icon">
                              <FontAwesomeIcon icon={faStop} fixedWidth />
                            </span>
                          ) : (
                            <span className="icon">
                              <FontAwesomeIcon icon={faPlay} fixedWidth />
                            </span>
                          )}
                        </button>
                        <button
                          className="button is-info is-small mx-1 px-3"
                          onClick={() => handleDownload(item)}
                        >
                          <span className="icon">
                            <FontAwesomeIcon icon={faDownload} fixedWidth />
                          </span>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div>
              <div className="columns">
                <div className="column is-5">
                  {data.map((item, index) => {
                    const isPlaying = playingItem && playingItem.fileName === item.fileName;
                    if (!isPlaying) return null;

                    const handleAudioEnded = () => setPlayingItem(null);

                    return (
                      <div key={index} className="column is-fullwidth is-narrow border p-2 my-4 bg-gray-50 rounded">
                        <p>
                          {/* Reproduzindo: <strong>{item.fileName}</strong> (Cliente: {item.tenant}, Tipo do áudio: {item.folder}) */}
                          {/* Reproduzindo: <strong>{item.fileName}</strong>) */}
                        </p>
                        <audio
                          controls
                          autoPlay
                          style={{ width: "100%" }}
                          src={ getPlayUrl(item) }
                          onEnded={ handleAudioEnded }
                        >
                          Seu navegador não suporta o elemento <code>áudio</code>.
                        </audio>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
